'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
/* eslint-disable max-len */
/* eslint-disable quote-props */
exports.default = {
  default: {},
  eukdlx: {
    default: {
      'updateLoginPath': function updateLoginPath(_ref) {
        var country = _ref.country,
            language = _ref.language,
            brand = _ref.brand;
        return '/bin/api/login-shop?page=/content/akzonobel-flourish/' + brand + '/' + country + '/' + language;
      }
    },
    'en-GB': {}
  },
  eukexp: {
    default: {
      'termsConditionsPath': function termsConditionsPath(_ref2) {
        var language = _ref2.language;
        return '/' + language + '/terms';
      },
      'termsOfUsePath': function termsOfUsePath(_ref3) {
        var language = _ref3.language;
        return '/' + language + '/terms';
      },
      'cookiePolicyPath': function cookiePolicyPath(_ref4) {
        var language = _ref4.language;
        return '/' + language + '/cookies';
      },
      'updateLoginPath': function updateLoginPath(_ref5) {
        var country = _ref5.country,
            language = _ref5.language;
        return '/bin/api/login-shop?page=/content/akzonobel-painters/duluxtrade/' + country + '/' + language;
      }
    }
  },
  enlflx: {
    default: {
      'updateLoginPath': function updateLoginPath(_ref6) {
        var country = _ref6.country,
            language = _ref6.language,
            brand = _ref6.brand;
        return '/bin/api/login-shop?page=/content/akzonobel-flourish/' + brand + '/' + country + '/' + language;
      }
    }
  },
  ebelev: {
    default: {
      'updateLoginPath': function updateLoginPath(_ref7) {
        var country = _ref7.country,
            language = _ref7.language,
            brand = _ref7.brand;
        return '/bin/api/login-shop?page=/content/akzonobel-flourish/' + brand + '/' + country + '/' + language;
      },
      'forgotPasswordPath': function forgotPasswordPath(_ref8) {
        var language = _ref8.language;
        return '/' + language + '/forgot-password';
      },
      'termsConditionsPath': function termsConditionsPath(_ref9) {
        var language = _ref9.language;
        return '/' + language + '/algemene-verkoopsvoorwaarden-overeenkomst';
      },
      'termsOfUsePath': function termsOfUsePath(_ref10) {
        var language = _ref10.language;
        return '/' + language + '/wettelijke-bepalingen';
      },
      'privacyPolicyPath': function privacyPolicyPath(_ref11) {
        var language = _ref11.language;
        return '/' + language + '/privacybeleid';
      }
    },
    'fr-BE': {
      'updateLoginPath': function updateLoginPath(_ref12) {
        var country = _ref12.country,
            language = _ref12.language,
            brand = _ref12.brand;
        return '/bin/api/login-shop?page=/content/akzonobel-flourish/' + brand + '/' + country + '/' + language;
      },
      'forgotPasswordPath': function forgotPasswordPath(_ref13) {
        var language = _ref13.language;
        return '/' + language + '/mot-de-passe-oubli\xE9';
      },
      'termsConditionsPath': function termsConditionsPath(_ref14) {
        var language = _ref14.language;
        return '/' + language + '/conditions-g%C3%A9n%C3%A9rales-de-vente-%C2%AB-contrat-%C2%BB';
      },
      'termsOfUsePath': function termsOfUsePath(_ref15) {
        var language = _ref15.language;
        return '/' + language + '/mentions-legales';
      },
      'privacyPolicyPath': function privacyPolicyPath(_ref16) {
        var language = _ref16.language;
        return '/' + language + '/protection-de-la-vie-priv%C3%A9e';
      }
    }
  },
  eiedlx: {
    default: {
      'updateLoginPath': function updateLoginPath(_ref17) {
        var country = _ref17.country,
            language = _ref17.language,
            brand = _ref17.brand;
        return '/bin/api/login-shop?page=/content/akzonobel-flourish/' + brand + '/' + country + '/' + language;
      }
    }
  },
  ebewdc: {
    default: {
      'privacyPolicyPath': function privacyPolicyPath(_ref18) {
        var language = _ref18.language;
        return '/' + language + '/privacyverklaring';
      },
      'termsConditionsPath': function termsConditionsPath(_ref19) {
        var language = _ref19.language;
        return '/' + language + '/wettelijke-bepalingen';
      },
      'cookies': function cookies(_ref20) {
        var language = _ref20.language;
        return '/' + language + '/cookies';
      }
    },
    'fr-BE': {
      'privacyPolicyPath': function privacyPolicyPath(_ref21) {
        var language = _ref21.language;
        return '/' + language + '/declaration-confidentialite';
      },
      'termsConditionsPath': function termsConditionsPath(_ref22) {
        var language = _ref22.language;
        return '/' + language + '/mentions-legales';
      },
      'cookies': function cookies(_ref23) {
        var language = _ref23.language;
        return '/' + language + '/cookies';
      }
    }
  },
  eukher: {
    default: {
      'productsPath': function productsPath(_ref24) {
        var language = _ref24.language;
        return '/' + language + '/our-products';
      }
    }
  },
  enlwdc: {
    default: {
      'privacyPolicyPath': function privacyPolicyPath(_ref25) {
        var language = _ref25.language;
        return '/' + language + '/privacybeleid';
      },
      'termsConditionsPath': function termsConditionsPath(_ref26) {
        var language = _ref26.language;
        return '/' + language + '/gebruiksvoorwaarden';
      },
      'salesConditionsPath': function salesConditionsPath(_ref27) {
        var language = _ref27.language;
        return '/' + language + '/verkoopvoorwaarden';
      },
      'cookies': function cookies(_ref28) {
        var language = _ref28.language;
        return '/' + language + '/cookiebeleid';
      },
      'productsPath': function productsPath(_ref29) {
        var language = _ref29.language;
        return '/' + language + '/productoverzicht';
      }
    }
  },
  edeexp: {
    default: {
      'privacyPolicyPath': function privacyPolicyPath(_ref30) {
        var language = _ref30.language;
        return '/' + language + '/datenschutzerkl\xE4rung';
      },
      'termsConditionsPath': function termsConditionsPath(_ref31) {
        var language = _ref31.language;
        return '/' + language + '/allgemeine-nutzungsbedingungen';
      },
      'salesConditionsPath': function salesConditionsPath(_ref32) {
        var language = _ref32.language;
        return '/' + language + '/allgemeine-nutzungsbedingungen';
      },
      'cookies': function cookies(_ref33) {
        var language = _ref33.language;
        return '/' + language + '/cookies';
      },
      'productsPath': function productsPath(_ref34) {
        var language = _ref34.language;
        return '/' + language + '/produkte';
      },
      'coloursPath': function coloursPath(_ref35) {
        var language = _ref35.language;
        return '/' + language + '/produkte';
      }
    }
  },
  enlexp: {
    default: {
      'privacyPolicyPath': function privacyPolicyPath(_ref36) {
        var language = _ref36.language;
        return '/' + language + '/privacy-statement';
      },
      'termsConditionsPath': function termsConditionsPath(_ref37) {
        var language = _ref37.language;
        return '/' + language + '/verkoopvoorwaarden';
      },
      'termsOfUsePath': function termsOfUsePath(_ref38) {
        var language = _ref38.language;
        return '/' + language + '/gebruiksvoorwaarden';
      },
      'cookies': function cookies(_ref39) {
        var language = _ref39.language;
        return '/' + language + '/cookiebeleid';
      },
      'productsPath': function productsPath(_ref40) {
        var language = _ref40.language;
        return '/' + language + '/producten';
      },
      'coloursPath': function coloursPath(_ref41) {
        var language = _ref41.language;
        return '/' + language + '/producten';
      }
    }
  },
  eesbru: {
    default: {
      'privacyPolicyPath': function privacyPolicyPath(_ref42) {
        var language = _ref42.language;
        return '/' + language + '/pol\xEDtica-de-privacidad';
      },
      'termsConditionsPath': function termsConditionsPath(_ref43) {
        var language = _ref43.language;
        return '/' + language + '/terms-and-conditions';
      },
      'termsOfUsePath': function termsOfUsePath(_ref44) {
        var language = _ref44.language;
        return '/' + language + '/terms-and-conditions';
      },
      'cookies': function cookies(_ref45) {
        var language = _ref45.language;
        return '/' + language + '/declaracion-de-cookies';
      },
      'productsPath': function productsPath(_ref46) {
        var language = _ref46.language;
        return '/' + language + '/productos';
      },
      'coloursPath': function coloursPath(_ref47) {
        var language = _ref47.language;
        return '/' + language + '/carta-de-colores';
      }
    }
  }
};
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./config/localisedPathOverrides.js
// module id = 2421
// module chunks = 0